export default interface AlertState {
    id: string,
    name: string,
}

export enum AlertStateValues {
    ACTIVE = '1',
    INACTIVE = '2',
}